import { getSettingsServicesApi as generatedGetSettingsServicesApi } from '../generated/settingsServices/getSettingsServices';

import { getSettingsServiceByIdApi } from './getSettingsServiceById';

const getSettingsServicesApi = generatedGetSettingsServicesApi.enhanceEndpoints({
  endpoints: {
    getSettingsServices: {
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        for (const service of data) {
          dispatch(
            getSettingsServiceByIdApi.util.upsertQueryData(
              'getSettingsServiceById',
              { serviceId: service._id },
              service,
            ),
          );
        }
      },
      providesTags: (result) => [
        'Services',
        ...(result?.map(({ _id: id }) => ({ id, type: 'Services' as const })) ?? []),
      ],
    },
  },
});

export const { useGetSettingsServicesQuery } = getSettingsServicesApi;
